import {
  CButton,
  CCol,
  CInput,
  CLabel,
  CRow,
  CCardHeader,
  CSpinner,
  CInvalidFeedback,
} from "@coreui/react";
import React, { useState, useEffect } from "react";
import { apiCall } from "src/_apiConfig/apiCall";
import { useParams, useHistory } from "react-router-dom";
const EditCircle = () => {
  let { id } = useParams();

  const history = useHistory();
  // eslint-disable-next-line no-unused-vars
  const [usersData, setuserData] = useState();
  const [loading, setloading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [circleId, setcircleId] = useState(id);
  const [name, setname] = useState();
  const [desc, setDesc] = useState();
  const [status, setstatus] = useState();

  const getCircleForEdit = async () => {
    setloading(true);
    const header = new Headers();
    const response = await apiCall(
      `Circle_Master?$filter=circleId%20eq%20 ${id}`,
      "GET",
      header,
      null
    );

    const jsonobj = await response.json();
    if (response?.ok) {
      setname(jsonobj[0].name);
      setDesc(jsonobj[0].desc);
      setstatus(jsonobj[0].status);
    }
    setloading(false);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => getCircleForEdit(), []);

  const goBack = () => {
    window.location.href = "/master/circlelist";
  };
  const EditCirclelist = async () => {
    setloading(true);
    const header = new Headers();

    header.append("Content-Type", "application/json");
    const response = await apiCall(
      `Circle_Master/update`,
      "PUT",
      header,
      JSON.stringify({
        circleId: Number(circleId),
        name: name,
        desc: desc,
        status: status,
      })
    );
    if (response?.ok) {
      //goBack();
      history.push("/master/circlelist");
      // const jsonobj = await response.json();
      // setuserData(jsonobj);
    }
    setloading(false);
  };
  return (
    <>
      <CCardHeader className="mb-5">
        <CRow className="pt-3" xl={12}>
          <CCol xl={10}>
            <h3>Edit Circle</h3>
          </CCol>
        </CRow>
        <hr />

        <CRow className="mb-3">
          <CCol xl={2}>
            <CLabel
              htmlFor="validationCustom01"
              className="col-sm-12 col-form-label"
            >
              Name:
            </CLabel>
          </CCol>
          <CCol xl={2}>
            <CInput
              placeholder=""
              value={name === null ? " " : name}
              onChange={(e) => setname(e.target.value)}
              required
              id="validationCustom01"
              invalid={name === "" ? true : false}
            />
            <CInvalidFeedback className="validationCustom01">
              Please enter Name
            </CInvalidFeedback>
          </CCol>
        </CRow>
        <CRow className="mb-3">
          <CCol xl={2}>
            <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
              Discription :
            </CLabel>
          </CCol>
          <CCol xl={2}>
            <CInput
              placeholder=""
              value={desc === null ? " " : desc}
              onChange={(e) => setDesc(e.target.value)}
              required
              id="validationCustom02"
              invalid={desc === "" ? true : false}
            />
            <CInvalidFeedback className="validationCustom02">
              Please enter Discription
            </CInvalidFeedback>
          </CCol>
        </CRow>
        <CRow className="mb-3">
          <CCol xl={2}>
            <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
              Status:
            </CLabel>
          </CCol>
          <CCol xl={2}>
            <input
              placeholder=""
              type="checkbox"
              checked={status ? status : false}
              onChange={() => setstatus(!status)}
            />{" "}
            <CInvalidFeedback className="validationCustom02">
              Please enter description
            </CInvalidFeedback>
          </CCol>
        </CRow>
        <CRow className="mb-3">
          <CCol xl={2}>
            {loading ? (
              <CSpinner className="spinner-grow" color="success" />
            ) : (
              <div>
                <CButton
                  className="ml-3"
                  color="success"
                  variant="outline"
                  onClick={() => EditCirclelist()}
                >
                  Save
                </CButton>

                <CButton className="ml-3" color="danger" onClick={goBack}>
                  Cancel
                </CButton>
              </div>
            )}
          </CCol>
        </CRow>
      </CCardHeader>
    </>
  );
};
export default EditCircle;
